export default __webpack_public_path__ + "static/media/aboutme-dark.070dd77f.webp";